import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aduan-block-card-skeleton',
  templateUrl: './aduan-block-card-skeleton.component.html',
  styleUrls: ['./aduan-block-card-skeleton.component.scss'],
})
export class AduanBlockCardSkeletonComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
